import React from 'react';

import NextImage from 'next/image';

import { Container } from '../../../../components/Container/Container';
import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import { useIsDesktopDevice } from '../../../../helpers/hooks/useIsDesktopDevice';
import arrow from '../../assets/BenefitsSection/arrow.svg';
import fish from '../../assets/BenefitsSection/fish.svg';
import rocket from '../../assets/BenefitsSection/rocket.svg';
import { DESKTOP_BENEFITS_IMAGE_SIZE, MOBILE_BENEFITS_IMAGE_SIZE } from '../../constants/constants';

import styles from './BenefitsSection.module.css';

export const BenefitsSection = () => {
  const isDesktopDevice = useIsDesktopDevice();
  const imageSize = !isDesktopDevice ? MOBILE_BENEFITS_IMAGE_SIZE : DESKTOP_BENEFITS_IMAGE_SIZE;

  return (
    <div className="grid grid-cols-1 grid-rows-1" data-testid="BenefitsSection">
      {/* Background */}
      <div className="col-start-1 row-start-1 grid w-full grid-cols-1 grid-rows-1">
        <div
          className={`mb-px size-full bg-cover bg-center bg-no-repeat ${styles.benefitsBackground}`}
          role="img"
          title="usMapBackground"
        />
      </div>
      {/* Content */}
      <Container className="my-xl col-start-1 row-start-1 grid w-full grid-cols-1 grid-rows-1">
        <Heading className="mb-3 md:mb-24 md:text-center" variant="xl">
          The benefits of advertising at Fishbrain
        </Heading>

        <div className="flex flex-col md:flex-row md:justify-around">
          <div className="flex w-full items-center p-4 md:w-1/3 md:flex-col">
            <NextImage
              width={imageSize}
              height={imageSize}
              src={arrow}
              alt="fish icon"
              className="mb-2"
            />
            <div className="ml-4 flex flex-col items-start md:ml-0 md:items-center">
              <Heading as="h3" variant="sm" className="mb-0 md:mb-2">
                Target your audience
              </Heading>
              <Text variant="md" className="md:text-center">
                100% are anglers. Fishbrain helps you reach relevant consumers for your business.
              </Text>
            </div>
          </div>
          <div className="flex w-full items-center p-4 md:w-1/3 md:flex-col">
            <NextImage
              width={imageSize}
              height={imageSize}
              src={rocket}
              alt="gear icon"
              className="mb-2"
            />
            <div className="ml-4 flex flex-col items-start md:ml-0 md:items-center">
              <Heading as="h3" variant="sm" className="mb-0 md:mb-2">
                Increase brand awareness
              </Heading>
              <Text variant="md" className="md:text-center">
                Advertising on Fishbrain helps you expand the reach and recognition of your brand.
              </Text>
            </div>
          </div>
          <div className="flex w-full items-center p-4 md:w-1/3 md:flex-col">
            <NextImage
              width={imageSize}
              height={imageSize}
              src={fish}
              alt="personal bests icon"
              className="mb-2"
            />
            <div className="ml-4 flex flex-col items-start md:ml-0 md:items-center">
              <Heading as="h3" variant="sm" className="mb-0 md:mb-2">
                Optimal ad placement
              </Heading>
              <Text variant="md" className="md:text-center">
                Advertise to a highly targeted audience and be in the spotlight with placements
                designed for maximum visibility and engagement.
              </Text>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
